import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { concatMap, delay, map, of, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserState } from '../store/user/user.reducer';
import { UserDetails } from '../components/login/user.model';
import { MatDialog } from '@angular/material/dialog';
import { TermsPrivacyDialogComponent } from '../components/custom/terms-privacy-dialog/terms-privacy-dialog.component';
import { AuthService } from '../services/auth.service';

export const privacyTermsGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);
  const authService = inject(AuthService);
  const dialogService = inject(MatDialog);

  return authService.user.pipe(
    delay(200),
    map((user) => {
      const isAuth = !!user;
      // if (isAuth) {
      //   return true;
      // }
      return { isAuth, user };
    }),
    concatMap(({ isAuth, user }) => {
      // if user is authenticated send user query to check if user has accepted the agreements
      if (isAuth) {
        return userService.checkUserAgreement().pipe(
          map((res) => {
            return {
              isAuth: isAuth,
              acceptedAgreements: res.data.user.accepted_agreements,
              userData: user,
            };
          })
        );
      } else {
        return of({
          isAuth: isAuth,
          acceptedAgreements: false,
          userData: user,
        });
      }
    }),
    map(({ isAuth, acceptedAgreements, userData }) => {
      // if user is authenticated and has not accepted terms, open dialog to accept user agreements
      if (isAuth) {
        if (acceptedAgreements) {
          return true;
        } else {
          const dialogRef = dialogService.open(TermsPrivacyDialogComponent, {});
          dialogRef.afterClosed().subscribe({
            next: (result) => {
              // console.log('result of terms & privacy dialog', result);
              if (result.confirm === false) {
                authService.logout();
                router.navigate(['/login']);
              } else if (result.confirm) {
                // mutate user profile to accpet agreements field to true
                userService.userAcceptAppTerms(userData.id).subscribe({
                  next: (res) => {
                    // console.log('accpet terms mutations result', res);
                    // continue to route
                  },
                });
                return router.navigate(['app/lots']);
              }
            },
          });
        }
      }
      // console.log('use is unauthed');
      return false;
    })
  );
};
